"use client";

import { Flex, Image } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

import MButton from "components/atoms/Button";
import MText from "components/atoms/Text";
import colors from "styles/customTheme/colors";
import Images from "styles/image-library";
import { replaceStringWithLink } from "utils/replace-string-w-link";

export default function Error() {
  const { t } = useTranslation();

  return (
    <Flex direction="column" bg={colors.greenLight} height="100vh">
      <head>
        <title>{t("errorPage.tab-title")}</title>
      </head>
      <Flex
        flex={1}
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        width="100vw"
        pt="120px"
        px={4}
      >
        <Image
          width={["95%", "60%", "50%"]}
          src={Images.error}
          alt="Error Illustration"
        />
        <MText
          type="text-xl"
          color={colors.black}
          pt={[6, 12]}
          maxWidth="800px"
        >
          {t("errorPage.description")}
        </MText>
        <MText
          type="text-xl"
          color={colors.black}
          pt={[4, 6]}
          pb={[6, 12]}
          maxWidth="800px"
        >
          {replaceStringWithLink(
            t("errorPage.contact-option") ?? "",
            "text-xl"
          )}
        </MText>
        <MButton
          variant="solid"
          width="200px"
          height="48px"
          font="text-xl"
          mb={["40px", "80px"]}
          href="/"
        >
          {t("errorPage.go-to-homepage")}
        </MButton>
      </Flex>
    </Flex>
  );
}
